import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import Card from "react-bootstrap/Card";

import { useEsus } from "@/hooks/useEsus";
import { getQuarterDates } from "@/utils/quarters";

import { IndicatorsEsbFilters } from "./IndicatorEsbFilters";
import { IndicatorEsbB1 } from "./IndicatorEsbB1";
import { IndicatorEsbB2 } from "./IndicatorEsbB2";
import { IndicatorEsbB3 } from "./IndicatorEsbB3";
import { IndicatorEsbB4 } from "./IndicatorEsbB4";
import { IndicatorEsbB5 } from "./IndicatorEsbB5";
import { IndicatorEsbB6 } from "./IndicatorEsbB6";

export function IndicatorsEsb() {
	const { indicator } = useParams();
	const { healthTeams } = useEsus();
	const [selectedIne, setSelectedIne] = useState<string>();
	const [selectedIndicator, setSelectedIndicator] = useState<number>(
		indicator ? Number(indicator) : 1
	);
	const quarter = Math.ceil((dayjs().month() + 1) / 4);
	const now = dayjs();
	const currentYear = now.year();
	const currentMonth = now.month();
	const [selectedQuarter, setSelectedQuarter] = useState<string>(`Q${quarter}/${currentYear}`);
	const [selectedMonth, setSelectedMonth] = useState<string>(
		String(currentMonth + 1).padStart(2, "0")
	);
	const [isPendingToUpdate, setIsPendingToUpdate] = useState(true);
	const selectedYear = dayjs(getQuarterDates(selectedQuarter).startDate).year();
	const selectedMonthNumber = Number(selectedMonth);

	const indicatorProps = {
		selectedQuarter,
		selectedYear,
		selectedMonth: selectedMonthNumber,
		selectedIne,
		isPendingToUpdate,
		setIsPendingToUpdate,
	};
	function getSelectedIndicator() {
		switch (selectedIndicator) {
			case 1:
				return <IndicatorEsbB1 {...indicatorProps} />;
			case 2:
				return <IndicatorEsbB2 {...indicatorProps} />;
			case 3:
				return <IndicatorEsbB3 {...indicatorProps} />;
			case 4:
				return <IndicatorEsbB4 {...indicatorProps} />;
			case 5:
				return <IndicatorEsbB5 {...indicatorProps} />;
			case 6:
				return <IndicatorEsbB6 {...indicatorProps} />;
			default:
				return <></>;
		}
	}

	useEffect(() => {
		setIsPendingToUpdate(true);
	}, [selectedIndicator]);

	return (
		<>
			<Card className="m-3 p-2">
				<Card.Body>
					<IndicatorsEsbFilters
						selectedIndicator={selectedIndicator}
						setSelectedIndicator={setSelectedIndicator}
						selectedQuarter={selectedQuarter}
						setSelectedQuarter={setSelectedQuarter}
						selectedMonth={selectedMonth}
						setSelectedMonth={setSelectedMonth}
						selectedIne={selectedIne}
						setSelectedIne={setSelectedIne}
						healthTeams={healthTeams}
						handleFilter={() => setIsPendingToUpdate(true)}
					/>
				</Card.Body>
			</Card>
			{getSelectedIndicator()}
		</>
	);
}
